import "./About.css";
import React from "react";
import p1 from "./images/IMG_7026.PNG";
import p2 from "./images/IMG_1637.jpg";
import p3 from "./images/party-parlour-photo3.jpg";
import p4 from "./images/Sip_N_Savour Booth Shot.jpg";

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <div className="about-hero-text">
            <h1>About The Party Parlour</h1>
            <p className="lead">
              We capture moments that matter. With high-quality photo booths and reliable, friendly service, we make every event feel effortless, fun, and unforgettable.
            </p>
          </div>
          <div className="about-hero-image">
            <div className="image-frame-large">
              <img src={p1} alt="Photo booth setup" className="hero-img" />
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-content">
        <div className="about-container">
          {/* Section 1 */}
          <div className="about-section">
            <div className="about-section-content">
              <div className="about-text-block">
                <h2>Events People Remember</h2>
                <p>
                  We turn moments into memories — the kind guests talk about long after the night ends. Every photo tells a story, and we're here to help you tell yours beautifully.
                </p>
                <p>
                  Our commitment to excellence means we arrive prepared, set up efficiently, and ensure your guests have an amazing experience from start to finish.
                </p>
              </div>
              <div className="about-image-block">
                <div className="image-frame-medium">
                  <img src={p2} alt="Event celebration" className="section-img" />
                </div>
              </div>
            </div>
          </div>

          {/* Section 2 */}
          <div className="about-section alt">
            <div className="about-section-content reverse">
              <div className="about-image-block">
                <div className="image-frame-medium">
                  <img src={p3} alt="Photo booth experience" className="section-img" />
                </div>
              </div>
              <div className="about-text-block">
                <h2>A Team That Fits the Vibe</h2>
                <p>
                 We match your vibe, blending seamlessly into the energy of your event. Our team is professional, friendly, and dedicated to making your event a success.
                </p>
                <p>
                  From the initial consultation to the final photo delivery, we're with you every step of the way, ensuring a seamless experience that exceeds expectations.
                </p>
              </div>
            </div>
          </div>

          {/* Section 3 */}
          <div className="about-section">
            <div className="about-section-content">
              <div className="about-text-block">
                <h2>Designed With Intention</h2>
                <p>
                  Sleek, modern setups that elevate a room — a booth styled as beautifully as the event itself. We bring professional-grade equipment and elegant design to every occasion.
                </p>
                <p>
                  Our attention to detail extends beyond the photos. Every backdrop, prop, and lighting choice is carefully considered to create the perfect atmosphere for your celebration.
                </p>
              </div>
              <div className="about-image-block placeholder">
                <div className="image-frame-medium placeholder-frame">
                  <div className="placeholder-content">
                    <img src={p4} alt="Photo booth experience" className="section-img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="values-container">
          <h2>Why Choose Us</h2>
          <div className="values-grid">
            <div className="value-item">
              <div className="value-icon">⭐</div>
              <h3>Premium Quality</h3>
              <p>Professional equipment and high-resolution output</p>
            </div>
            <div className="value-item">
              <div className="value-icon">🎯</div>
              <h3>Reliable Service</h3>
              <p>On-time setup and professional conduct</p>
            </div>
            <div className="value-item">
              <div className="value-icon">💎</div>
              <h3>Elegant Design</h3>
              <p>Beautiful setups that complement your event</p>
            </div>
            <div className="value-item">
              <div className="value-icon">🚀</div>
              <h3>Fast Delivery</h3>
              <p>Instant digital access and on-site prints</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
